import '../../styles/amentities.css';
import Tick from './Tick';
import translateToPolish from './Translation';

export default function Specification({data}) {
    return (
    <div className="specification">
        <h5>Udogodnienia</h5>
      {Object.entries(data).map(([category, items]) => (
        <div key={category}>
          <h6>{translateToPolish(category).charAt(0).toUpperCase() + translateToPolish(category).slice(1).toLowerCase()}</h6>
          <ul>
            {items.map((item) => (
              <li key={item.id}><Tick key={item.id}/>{translateToPolish(item)}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}